module.exports = __webpack_public_path__ + "img/collect_manual.6bcfc8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/collect_manual.svg
// module id = 3wb/
// module chunks = 1